import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTicket: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"ticket, admit, vip"} maskId="square-filled-radius-0-stroke-1-IconTicket"><path fillRule="evenodd" clipRule="evenodd" d="M2 10V4H22V10H21.5C20.3954 10 19.5 10.8954 19.5 12C19.5 13.1046 20.3954 14 21.5 14H22V20H2V14H2.5C3.60457 14 4.5 13.1046 4.5 12C4.5 10.8954 3.60457 10 2.5 10H2ZM16 7H15V9H16V7ZM16 11H15V13H16V11ZM16 15H15V17H16V15Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconTicket;
